export default "__VITE_ASSET__BI4f1Qgy__";